export enum ResponseErrorCode {
  ExpiredAccessToken = 'OC_ACCESS_TOKEN_EXPIRED_ERROR',
  InvalidAccessToken = 'INVALID_ACCESS_TOKEN_ERROR',
}
